import React from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import clone from 'clone';
import axios from "axios";
import { themeConfig } from '../../settings';
import appActions from '../../redux/app/actions';
import IntlMessages from '../../components/utility/intlMessages';
import Logo from '../../components/utility/logo';
import Menu from '../../components/uielements/menu';
import Spin from "../../components/uielements/spin";
import options from './options';
import Scrollbars from '../../components/utility/customScrollBar.js';
import SidebarWrapper from './sidebar.style';
import themes from '../../settings/themes';
import { SERVER_ADDRESS } from '../../settings';
import { getToken, Roles, getTicketCredentials } from '../../helpers/utility';
import { Settings, GetSettingValues } from "../../helpers/Settings/Enums";

var TOKEN = "";

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

var usrRoles = null;

const {
    toggleOpenDrawer,
    changeOpenKeys,
    changeCurrent,
    toggleCollapsed
} = appActions;

const stripTrailingSlash = str => {
    if (str.substr(-1) === '/') {
        return str.substr(0, str.length - 1);
    }
    return str;
};

class Sidebar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            userRoles: [],
            userSideBarPerms: [],
            usesIframe: false,
            hideNotifications: false,
            loadingIDBox: false,
            PowerBIActive: false,
            DataStudioActive: false,
            QlikSenseActive: false,
            userRoleType: undefined
        };

        this.handleClick = this.handleClick.bind(this);
        this.onOpenChange = this.onOpenChange.bind(this);
        this.sendToIDBox = this.sendToIDBox.bind(this);
    }

    handleClick(e) {
        this.props.changeCurrent([e.key]);
        if (this.props.app.view === 'MobileView') {
            setTimeout(() => {
                this.props.toggleCollapsed();
                this.props.toggleOpenDrawer();
            }, 100);
        }
    }

    onOpenChange(newOpenKeys) {
        const { app, changeOpenKeys } = this.props;
        const latestOpenKey = newOpenKeys.find(
            key => !(app.openKeys.indexOf(key) > -1)
        );
        const latestCloseKey = app.openKeys.find(
            key => !(newOpenKeys.indexOf(key) > -1)
        );
        let nextOpenKeys = [];
        if (latestOpenKey) {
            nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
        }
        if (latestCloseKey) {
            nextOpenKeys = this.getAncestorKeys(latestCloseKey);
        }
        changeOpenKeys(nextOpenKeys);
    }

    getAncestorKeys = key => {
        const map = {
            sub3: ['sub2']
        };
        return map[key] || [];
    };

    getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
        const { key, label, leftIcon, children, separatorTitle, external, space } = singleOption;
        const url = stripTrailingSlash(this.props.url);
        let ticketCredentials = getTicketCredentials();
        if (ticketCredentials == null)
            ticketCredentials = {
                url: null
            };

        if (separatorTitle) {
            return (
                <Menu.Item key={key} disabled style={{ size: 25 }}>
                    <span className="isoMenuHolder" style={submenuColor}>
                        <span className="nav-text">
                            <IntlMessages id={separatorTitle} />
                        </span>
                    </span>
                </Menu.Item>
            );
        }

        if (space) {
            return (
                <div key={key} style={{ margin: "5px" }} />
            )
        }

        if (children) {
            return (
                <SubMenu
                    key={key}
                    title={
                        <span className="isoMenuHolder" style={submenuColor}>
                            <i className={leftIcon} />
                            <span className="nav-text">
                                <IntlMessages id={label} />
                            </span>
                        </span>
                    }
                >
                    {
                        children.map(child => {
                            const linkTo = child.withoutDashboard
                                ? `/${child.key}`
                                : `${url}/${child.key}`;

                            return (
                                <Menu.Item style={submenuStyle} key={child.key}>
                                    <Link style={submenuColor} to={linkTo}>
                                        <IntlMessages id={child.label} />
                                    </Link>
                                </Menu.Item>
                            );
                        })
                    }
                </SubMenu>
            );
        }

        return (
            <Menu.Item key={key}>
                {external && this.state.usesIframe != true ?
                    key === "Veocob" ?
                        (<a id="Veocob" onClick={() => this.sendToVeoCob()}>
                            <span className="isoMenuHolder" style={submenuColor}>
                                {
                                    this.state.loadingIveocob ?
                                        <LoadingOutlined />
                                        :
                                        <i className={leftIcon} />
                                }
                                <span className="nav-text">
                                    <IntlMessages id={label} />
                                </span>
                            </span>
                        </a>)
                        :
                        key === "MyTickets" ?
                            (
                                ticketCredentials.sondeoOrIframe == false ? <a href={`${key === 'MyTickets' ? (ticketCredentials.url !== null ? ticketCredentials.url : "http://veoliaargentina.sondeosglobal.com/login") : singleOption.url}`} target="_blank">
                                    <span className="isoMenuHolder" style={submenuColor}>
                                        <i className={leftIcon} />
                                        <span className="nav-text">
                                            <IntlMessages id={label} />
                                        </span>
                                    </span>
                                </a>
                                    :
                                    <Link to={`${url}/${key}`}>
                                        <span className="isoMenuHolder" style={submenuColor}>
                                            <i className={leftIcon} />
                                            <span className="nav-text">
                                                <IntlMessages id={label} />
                                            </span>
                                        </span>
                                    </Link>
                            )
                            :
                            (<a id="MyIDBox" onClick={() => this.sendToIDBox()}>
                                <span className="isoMenuHolder" style={submenuColor}>
                                    {
                                        this.state.loadingIDBox ?
                                            <LoadingOutlined type="loading" />
                                            :
                                            <i className={leftIcon} />
                                    }
                                    <span className="nav-text">
                                        <IntlMessages id={label} />
                                    </span>
                                </span>
                            </a>)

                    :
                    (<Link to={`${url}/${key}`}>
                        <span className="isoMenuHolder" style={submenuColor}>
                            <i className={leftIcon} />
                            <span className="nav-text">
                                <IntlMessages id={label} />
                            </span>
                        </span>
                    </Link>)

                }
            </Menu.Item>
        );
    };

    sendToIDBox = () => {
        this.setState({ loadingIDBox: true });
        axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetIDBoxToken`, {
            headers: {
                Authorization: `Bearer ${TOKEN}`
            },
        }).then(resp => {
            axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetIDBoxCredentialInfo`, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                },
            }).then(data => {
                axios.post(resp.data,
                    `username=${data.data.username}&password=${data.data.password}&grant_type=password`, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                }).then(xdata => {
                    axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetWebToken?token=${xdata.data.access_token}`, {
                        headers: {
                            Authorization: `Bearer ${TOKEN}`,
                        }
                    }).then(zdata => {
                        this.setState({ loadingIDBox: false });
                        window.open(zdata.data);
                    });
                }).catch(err => {
                    this.setState({ loadingIDBox: false });
                    window.open("https://lat.veolia.idboxrt.com/?st=");
                });
            }).catch(err => {
                this.setState({ loadingIDBox: false });
                window.open("https://lat.veolia.idboxrt.com/?st=");
            });
        });
    }

    sendToVeoCob = () => {
        this.setState({ loadingIveocob: true });
        axios.get(`${SERVER_ADDRESS}/api/Veocob/GetUrl`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                }
            }
        ).then(data => {
            this.setState({ loadingIveocob: false });
            window.open(data.data.url);
        })
            .catch(data => {
                this.setState({ loadingIveocob: false });

            });

    }

    render() {
        const { app, toggleOpenDrawer, height } = this.props;
        const collapsed = clone(app.collapsed) && !clone(app.openDrawer);
        const { openDrawer } = app;
        const mode = collapsed === true ? 'vertical' : 'inline';
        const onMouseEnter = event => {
            if (openDrawer === false) {
                toggleOpenDrawer();
            }
            return;
        };
        const onMouseLeave = () => {
            if (openDrawer === true) {
                toggleOpenDrawer();
            }
            return;
        };
        const customizedTheme = themes[themeConfig.theme];
        const styling = {
            backgroundColor: customizedTheme.backgroundColor
        };
        const submenuStyle = {
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: customizedTheme.textColor
        };
        const submenuColor = {
            color: customizedTheme.textColor
        };
        return (
            <SidebarWrapper>
                <Sider
                    trigger={null}
                    collapsible={true}
                    collapsed={collapsed}
                    width={240}
                    className="isomorphicSidebar"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    style={styling}
                >
                    <Logo collapsed={collapsed} />
                    <Scrollbars style={{ height: height - 70 }}>
                        <Menu
                            onClick={this.handleClick}
                            theme="dark"
                            className="isoDashboardMenu"
                            mode={mode}
                            openKeys={collapsed ? [] : app.openKeys}
                            selectedKeys={app.current}
                            onOpenChange={this.onOpenChange}
                        >
                            {
                                options.map((singleOption) => {
                                    var visible = false;
                                    var usrRoles = this.getUserRoles();
                                    var usrPerms = this.getUserPerms();

                                    if (singleOption.APIKey !== undefined)
                                        if (usrPerms?.includes(singleOption.APIKey))
                                            visible = true;

                                    if (singleOption.visibleBy !== undefined) {
                                        if (usrRoles?.includes(Roles.ADMIN) || usrRoles?.includes(Roles.BACKOFFICE))
                                            visible = true;
                                    }


                                    if (visible) {
                                        if (singleOption.APIKey == "NotificationTab") {
                                            if (this.state.hideNotifications == false)
                                                return this.getMenuItem({ submenuStyle, submenuColor, singleOption });
                                        }
                                        else if (singleOption.APIKey == "DashboardTab" && (usrRoles?.includes(Roles.ADMIN) || usrRoles?.includes(Roles.BACKOFFICE) || usrRoles?.includes(Roles.GENERATOR))) {
                                            return this.getMenuItem({ submenuStyle, submenuColor, singleOption });
                                        }
                                        else if (singleOption.APIKey == "DataStudioTab") {
                                            if (this.state.DataStudioActive)
                                                return this.getMenuItem({ submenuStyle, submenuColor, singleOption });
                                        }
                                        else if (singleOption.APIKey == "QlikSenseDashboardTab" || singleOption.APIKey == "QlikSenseReportTab") {
                                            if (this.state.QlikSenseActive) {
                                                return this.getMenuItem({ submenuStyle, submenuColor, singleOption });
                                            }
                                        }
                                        else {
                                            return this.getMenuItem({ submenuStyle, submenuColor, singleOption });
                                        }
                                    } else {
                                        if (singleOption.APIKey == "DashboardTab" && (usrRoles?.includes(Roles.ADMIN) || usrRoles?.includes(Roles.BACKOFFICE) || usrRoles?.includes(Roles.CLIENT) || usrRoles?.includes(Roles.CLIENTGENERATOR))) {
                                            return this.getMenuItem({ submenuStyle, submenuColor, singleOption });

                                        }
                                    }
                                })}
                        </Menu>
                    </Scrollbars>
                </Sider>
            </SidebarWrapper>
        );
    }

    componentDidMount() {
        TOKEN = getToken();
        this.obtainTicketCredentials();
        this.fetch();
        this.usesIframe();
        this.ShowsNotifications();

        GetSettingValues(TOKEN, Settings.PowerBIActive).then(response => {
            this.setState({
                PowerBIActive: response.data == "1" ? true : false
            });
        });

        GetSettingValues(TOKEN, Settings.DataStudioActive).then(response => {
            this.setState({
                DataStudioActive: response.data == "1" ? true : false
            });
        });

        GetSettingValues(TOKEN, Settings.QlikSenseActive).then(response => {
            this.setState({
                QlikSenseActive: response.data == "1" ? true : false
            });
        });
    }

    obtainTicketCredentials = () => {
        axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetUserTicketCredentials`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`
                },
            }
        )
            .then(data => {
                localStorage.setItem('ticketCredentials', JSON.stringify(data.data));
            });
    };

    fetch = () => {
        axios.get(`${SERVER_ADDRESS}/api/Backoffice/User/GetUserVM`, {
            headers: {
                Authorization: `Bearer ${TOKEN}`
            }
        }).then(x => {
            usrRoles = x.data.roles;
            this.setState({
                userRoles: x.data.roles,
                userSideBarPerms: x.data.checkedSidebarVis,
                userRoleType: x.data.roleType
            });
        });
    }

    usesIframe = () => {
        axios.get(`${SERVER_ADDRESS}/api/Common/usesIframe`, {
            headers: {
                Authorization: `Bearer ${TOKEN}`
            }
        }).then(x => {
            this.setState({
                usesIframe: x.data
            });
        });
    }

    ShowsNotifications = () => {
        axios.get(`${SERVER_ADDRESS}/api/Common/ShowsNotifications`, {
            headers: {
                Authorization: `Bearer ${TOKEN}`
            }
        }).then(x => {
            this.setState({
                hideNotifications: x.data
            });
        });
    }

    getUserRoles = () => {
        if (this.state.userRoles?.length > 0) {
            return this.state.userRoles;
        }

        else {
            return this.state.userRoleType

        }

    }

    getUserPerms = () => {
        return this.state.userSideBarPerms;
    }
}

export default connect(
    state => ({
        app: state.App,
        height: state.App.height,
        locale: state.LanguageProvider.language.locale,
    }),
    { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar);
